import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Grid,
  makeStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Slider,
  withStyles,
  // FormControlLabel,
  Checkbox,
  Hidden,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import Razorpay from '../../assets/images/razorpay.png'
import { useHistory } from "react-router-dom";

const PaymentDetailsBus = () => {
  const history = useHistory();
  return (
    <>
      <header className="header">
        <a  className="logo">
          <img
            src="https://www.marinersforex.com/img/LOGO-MarinersForex.png"
            width="200px"
            height="50px"
            onClick={() => history.push("/")}
          ></img>
        </a>
      </header>
      <Container style={{ marginTop: 100 }}>
        <h2 style={{ color: "#3e3e52", fontFamily: "Montserrat" }}>
          Choose Payment Method
        </h2>
        <Grid container>
          <Grid item xs={8}>
            <Box style={{boxShadow:'0 3px 11px 0 rgb(0 0 0 / 12%)'}}>
<Box style={{borderRadius: '2px',
    backgroundColor: 'rgb(255, 255, 255)',
    padding: '1.3em',
    display: 'flex',
    // flex-direction: column;
    // -webkit-box-pack: center;
    // justifyContent: 'center',
    borderBottom: '1px solid rgb(221, 221, 221)'}}>
        {/* <img src={Razorpay} style={{width:20,height:20}}></img> */}
    <span style={{fontFamily:'Montserrat',fontSize:20}}>Pay through Razorpay</span>
</Box>
<Box style={{borderRadius: '2px',
    backgroundColor: 'rgb(255, 255, 255)',
    padding: '1.3em',
    display: 'flex',
    // flex-direction: column;
    // -webkit-box-pack: center;
    // justifyContent: 'center',
    borderBottom: '1px solid rgb(221, 221, 221)'}}>
    <span style={{fontFamily:'Montserrat',fontSize:20}}>Pay through Wallet</span>
</Box>
            </Box>
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid>
      </Container>
    </>
  );
};

export default PaymentDetailsBus;
